<template>
  <div class="container">
    <header class="jumbotron">
      <h3>Usuários</h3>
    </header>
    <Form @submit="handleFilter" :validation-schema="schema">
      <div class="col-md-5">
        <div class="card card-container">
          <div>
            <div class="form-group">
              <label for="userField">Usuário</label>
              <Field name="userField" type="text" class="form-control"  v-model="form.userField"/>
              <ErrorMessage name="userField" class="error-feedback" />
            </div>
            <div v-if="showAdminBoard" class="form-group">
              <label for="supervisor">Supervisor</label>
              <Field name="supervisor" as="select" class="form-control"  v-model="form.supervisor">
                <option value="">Selecione um supervisor</option>
                <option
                  v-for="i in supervisorOptions"
                  :value="i.value"
                  :key="i.value"
                >
                  {{ i.text }}
                </option>
              </Field>
              <ErrorMessage name="supervisor" class="error-feedback" />
            </div>
            <div v-if="showAdminBoard" class="form-group">
              <label for="type">Tipo</label>
              <Field name="type" as="select" class="form-control"  v-model="form.type">
                <option value="user">Usuario</option>
                <option value="supervisor">Supervisor</option>
                <option value="admin">Administrador</option>
              </Field>
              <ErrorMessage name="type" class="error-feedback" />
            </div>
            <div v-if="showAdminBoard" class="form-group">
              <label for="balance">Saldo maior que</label>
              <Field name="balance" type="number" class="form-control"  v-model="form.balance"/>
              <ErrorMessage name="balance" class="error-feedback" />
            </div>
            <div v-if="showAdminBoard" class="form-group">
              <label for="balance1">Saldo menor que</label>
              <Field name="balance1" type="number" class="form-control"  v-model="form.balance1"/>
              <ErrorMessage name="balance1" class="error-feedback" />
            </div>
            <div v-if="showAdminBoard" class="form-group">
              <label for="ativo">Ativo Ultimos X Dias</label>
              <Field name="ativo" type="number" class="form-control"  v-model="form.ativo"/>
              <ErrorMessage name="ativo" class="error-feedback" />
            </div>

            <div v-if="showAdminBoard" class="form-group">
              <label for="datestart">Data Inicio (AAAA-MM-DD)</label>
              <Field name="datestart" type="text" class="form-control"  v-model="form.datestart"/>
              <ErrorMessage name="datestart" class="error-feedback" />
            </div>
            <div v-if="showAdminBoard" class="form-group">
              <label for="dateend">Data Final (AAAA-MM-DD)</label>
              <Field name="dateend" type="text" class="form-control" v-model="form.dateend"/>
              <ErrorMessage name="dateend" class="error-feedback" />
            </div>

            <div class="form-group">
              <button class="btn btn-primary btn-block">Filtrar</button>
            </div>
          </div>
        </div>
      </div>
    </Form>
    <table>
      <thead>
        <tr>
          <th></th>
          <th v-if="showAdminBoard"></th>
          <th @click="sort('user')">
            {{ sortBy === "user" ? "*" : "" }}Usuário
          </th>
          <th @click="sort('email')">
            {{ sortBy === "email" ? "*" : "" }}E-Mail
          </th>
          <th @click="sort('supervisor')">
            {{ sortBy === "supervisor" ? "*" : "" }}Supervisor
          </th>
          <th @click="sort('type')" v-if="showAdminBoard">
            {{ sortBy === "type" ? "*" : "" }}Tipo
          </th>
          <th
            style="text-align: right; text-wrap: nowrap"
            @click="sort('balance')"
          >
            {{ sortBy === "balance" ? "*" : "" }}Saldo(R$
            {{ totalBalance.toFixed(2) }})
          </th>
          <th
            style="text-align: right; text-wrap: nowrap"
            @click="sort('limit')"
          >
            {{ sortBy === "limit" ? "*" : "" }}Envio Max.
          </th>
          <th
            v-if="showAdminBoard"
            style="text-align: right; text-wrap: nowrap"
            @click="sort('qtdsends')"
          >
            {{ sortBy === "qtdsends" ? "*" : "" }}Qtd. Envios({{
              totalQtdSends
            }})
          </th>
          <th
            v-if="showAdminBoard"
            style="text-align: right; text-wrap: nowrap"
            @click="sort('valuesends')"
          >
            {{ sortBy === "valuesends" ? "*" : "" }}Valor. Envios(R$
            {{ totalValueSends.toFixed(2) }})
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in sortedList" :key="`user-${index}`">
          <td style="text-align: center" class="td-flex">
            <router-link
              v-if="showAdminBoard"
              :to="'/register/' + row.id"
              class="nav-link"
              ><font-awesome-icon icon="pen-square"
            /></router-link>
            <a
              @click="checkin(row)"
              class="nav-link"
              :class="row.checkedin ? 'checkedin' : 'checkedout'"
            >
              <font-awesome-icon icon="user"
            /></a>
          </td>
          <td v-if="showAdminBoard">
            <input
              type="checkbox"
              :id="row.id"
              :value="row.id"
              v-model="checkedIds"
            />
          </td>
          <td>{{ row.user }}</td>
          <td>{{ row.email }}</td>
          <td>{{ row.supervisor }}</td>
          <td v-if="showAdminBoard">{{ row.type }}</td>
          <td style="text-align: right; text-wrap: nowrap">
            R$ {{ row.balance.toFixed(2) }}
          </td>
          <td style="text-align: right; text-wrap: nowrap">
            R$ {{ row.limit.toFixed(2) }}
          </td>
          <td
            v-if="showAdminBoard"
            style="text-align: right; text-wrap: nowrap"
          >
            {{ row.qtdsends }}
          </td>
          <td
            v-if="showAdminBoard"
            style="text-align: right; text-wrap: nowrap"
          >
            R$ {{ row.valuesends.toFixed(2) }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showAdminBoard" class="col-md-5">
      <div class="card card-container">
        <div>
          <div class="form-group">
            <label for="setBalance">Saldo</label>
            <Field
              name="setBalance"
              type="number"
              class="form-control"
              v-model="setBalance"
            />
            <ErrorMessage name="setBalance" class="error-feedback" />
          </div>

          <div class="form-group">
            <button
              @click="setSaldo()"
              class="btn btn-primary btn-block"
              :disabled="loading"
            >
              <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
              ></span>
              Setar saldo para {{ checkedIds.length }} usuários
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "Users",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({});
    return {
      loading: false,
      sortBy: "user",
      sortOrder: 1,
      perPage: 3,
      currentPage: 1,
      rows: [],
      schema,
      totalBalance: 0,
      totalQtdSends: 0,
      totalValueSends: 0,
      supervisorOptions: [],
      checkedIds: [],
      setBalance: 0,
      form:{
        userField: "",
        supervisor: "",
        type: "",
        balance: "",
        balance1: "",
        ativo: "",
        datestart: "",
        dateend: "",
      }
    };
  },
  mounted() {
    if (!this.currentUser || !this.loggedIn) {
      this.$root.logOut();
    }

    if (this.loggedIn) {
      if (this.showAdminBoard) {
        UserService.getListSupervisor().then(
          (response) => {
            if (response.data.result) {
              this.supervisorOptions = response.data.data;
            }
          },
          (error) => {
            this.supervisorOptions = [];
            console.log(
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString()
            );
            this.$root.logOut();
          }
        );
      }
      UserService.getListUserFull().then(
        (response) => {
          if (response.data.result) {
            this.rows = response.data.data;
            this.totalBalance = response.data.totalBalance;
            this.totalQtdSends = response.data.totalQtdSends;
            this.totalValueSends = response.data.totalValueSends;
          }
        },
        (error) => {
          this.rows = [];
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
        }
      );
    }
  },
  computed: {
    sortedList() {
      return [...this.rows]
        .map((i) => ({ ...i, sale_potential: parseFloat(i.sale_potential) }))
        .sort((a, b) => {
          if (typeof a[this.sortBy] === "string") {
            if (a[this.sortBy].toLowerCase() >= b[this.sortBy].toLowerCase()) {
              return this.sortOrder;
            }
            return -this.sortOrder;
          } else {
            if (a[this.sortBy] >= b[this.sortBy]) {
              return this.sortOrder;
            }
            return -this.sortOrder;
          }
        });
    },
    loggedIn() {
      return (
        this.$store.state.auth.status.loggedIn &&
        this.$store.state.auth.user.validOTP
      );
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser["roles"]) {
        return this.currentUser["roles"].includes("ROLE_ADMIN");
      }
      return false;
    },
  },
  methods: {
    sort: function (sortBy) {
      if (this.sortBy === sortBy) {
        this.sortOrder = -this.sortOrder;
      } else {
        this.sortBy = sortBy;
        this.sortOrder = 1;
      }
    },
    setSaldo() {
      this.message = "";
      this.successful = false;
      this.loading = true;
      UserService.setSaldo(this.checkedIds, this.setBalance).then(
        (response) => {
          if (response.data.result) {
            this.checkedIds = [];
            this.setBalance = 0;
            this.handleFilter({
              userField: this.form.userField,
              supervisor: this.form.supervisor,
              type: this.form.type,
              balance: this.form.balance,
              balance1: this.form.balance1,
              ativo: this.form.ativo,
              datestart: this.form.datestart,
              dateend: this.form.dateend,
            })
          }
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
    },
    handleFilter(data) {
      UserService.getUserFiltered(data).then(
        (response) => {
          if (response.data.result) {
            this.rows = response.data.data;
            this.totalBalance = response.data.totalBalance;
            this.totalQtdSends = response.data.totalQtdSends;
            this.totalValueSends = response.data.totalValueSends;
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.rows = [];
          confirm.error(error);
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    checkin(row) {
      UserService.checkin(row.id).then(
        (response) => {
          if (response.data.result) {
            row.checkedin = response.data.checkedin;
            for (var i in this.rows) {
              if (this.rows[i].id == row.id) {
                this.rows[i].checkedin = row.checkedin;
                break;
              }
            }
          }
        },
        (error) => {
          this.rows = [];
          console.log(
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
  },
};
</script>
<style scoped>
.td-flex {
  display: flex;
}
.checkedin {
  color: green;
}
.checkedout {
  color: red;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

th {
  cursor: pointer;
  background-color: #dddddd;
}
</style>